import React from "react";
import PropTypes from "prop-types";

// Components
import ReactPlayer from "react-player";

/**
 * React Video Player
 */

const FeaturedVideo = ({ videoUrl, imageUrl }) => {
	const playIconPath = `${mainScript.assetPath}images/svg/graphics/play-button.svg`;
	const playIcon = <img src={playIconPath} alt="play" className="play-icon" />;

	const imageOpacity = 0.8;

	if (!videoUrl) return null;

	return (
		<>
			{videoUrl?.includes("vimeo") ? (
				<ReactPlayer
					height="100%"
					width="100%"
					url={videoUrl}
					light={
						<img
							src={imageUrl}
							alt="thumbnail"
							style={{ opacity: imageOpacity }}
							loading="lazy"
						/>
					}
					playIcon={playIcon}
					playing={true}
					controls={true}
				/>
			) : videoUrl?.includes("youtu") ? (
				<ReactPlayer
					height="100%"
					width="100%"
					url={videoUrl}
					light={
						<img
							src={imageUrl}
							alt="thumbnail"
							style={{ opacity: imageOpacity }}
							loading="lazy"
						/>
					}
					playIcon={playIcon}
					playing={true}
					controls={true}
				/>
			) : (
				<div className="video-player__error">
					Sorry this video format is not supported.
				</div>
			)}
		</>
	);
};

FeaturedVideo.propTypes = {
	videoUrl: PropTypes.string,
	imageUrl: PropTypes.string,
};

export default FeaturedVideo;
